import { render, staticRenderFns } from "./NoteView.vue?vue&type=template&id=b0187ff4&"
import script from "./NoteView.vue?vue&type=script&lang=js&"
export * from "./NoteView.vue?vue&type=script&lang=js&"
import style0 from "./NoteView.vue?vue&type=style&index=0&id=b0187ff4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports